var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disposer-app-section-column"},[_c('div',{staticClass:"section-main"},[_vm._t("default")],2),_c('div',{staticClass:"section-footer"},[_c('div',{staticClass:"section-btns"},[_c('app-button',{staticClass:"section-btn red",on:{"click":_vm.save}},[_vm._v(" Save ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }